import { useContext } from "react";
import AppUrlContext from "../contexts/appUrlProvider";

const useAppUrl = () => {
    return useContext(AppUrlContext);
}

export default useAppUrl;